import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Group,
  Center,
  Select,
  Button,
  Pagination,
  Checkbox,
  Modal,
  TextInput,
  Tabs, 
  Divider,
  Paper,
  Grid,
  Stack,
  NumberInput,
  Box,
  Skeleton,
  Breadcrumbs, 
  Anchor,
  MultiSelect,
  FileButton,
  SimpleGrid,
  Image,
  ActionIcon,
} from "@mantine/core";
import {
  IconPhoto,
  IconSettings,
  IconPhotoCancel,
  IconPhotoPlus,
  IconCircleXFilled,
  IconPhotoX,
  IconX,
  IconPlus,
  IconMinus,
} from "@tabler/icons-react";
import { Dropzone } from "@mantine/dropzone";
import classes from "./WebOrderView.module.css";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";
import { useQuery, useMutation, useQueryClient  } from 'react-query';
import { useForm } from '@mantine/form';
import { Link, useLocation, useParams } from "react-router-dom";

import WebOrderUpdateModal from "./WebOrderUpdateModal";

import { formatYYYY_MM_DD, formatYYYY_MM_DD_HH_mm } from "../../helper/DateTime";

import { convertToCurrency } from "../../helper/Formatter";

export function WebOrderView() {
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient()
    const { id } = useParams();


    const [updateStatusVisible, setUpdateStatusVisible] = useState(false)


    const salesOrderQuery = useQuery(
        "getOrder",
        async ({ signal }) => (await axiosPrivate.post("/api/admin/sales-order/read-by-id", { salesId: id }, { signal })).data.data,
        {
            initialData: null,
            onSuccess: (res) => {

            },
            onError: (err: any) => {
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
            }
        }
    );

    const updateSalesOrderMutation = useMutation(
        (data: any) => axiosPrivate.post("/api/admin/sales-order/update", data, {headers: {'Content-Type': 'multipart/form-data'}}),
        {
            onSuccess: (res: any) => {
                queryClient.invalidateQueries({ queryKey: ['getOrder'] })
                showSuccessAlert("Order Successfully Updated");
            },
            onError:(err: any) => {
                // setAddRebateFormVisible(false);
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
            }
        }
    );

    const handleUpdateStatus = (data: any) => {
        let params = {
            salesOrderId: id,
            statusId: data.statusId,
            courierService: data.courierService,
            trackingNumber: data.trackingNumber,
        }
        updateSalesOrderMutation.mutate(params)
    }



  return (
    <div>
        <WebOrderUpdateModal
            isVisible={updateStatusVisible}
            onClose={() => setUpdateStatusVisible(false)}
            onUpdateStatus={(newData) => handleUpdateStatus(newData)}
            orderData={salesOrderQuery.data}
        />
        <div>
            <Header title="Web Order - View" />
            <Breadcrumbs mx={20} my={'sm'}>
                <Anchor component={Link} to={`/${location.pathname.split("/")[1]}`}>
                    Web Order
                </Anchor>
                <Anchor>
                    View
                </Anchor>
            </Breadcrumbs>
            <Box
                w={
                    window.innerWidth -
                    document.getElementById("nav-bar")!!.getBoundingClientRect().width
                }
                mt={"md"}
                
            >
                <Paper px={20}>
                    <Grid>
                        <Grid.Col span={{ base: 12, md: 8, lg: 6 }}>
                            <Skeleton visible={salesOrderQuery.isFetching || salesOrderQuery.isError} animate={!salesOrderQuery.isError}>
                            <Stack gap={'sm'}>
                            <Group justify="flex-end">
                                <Button onClick={()=>setUpdateStatusVisible(true)}>Update Status</Button>
                            </Group>
                            <div className={classes.orderCard}>
                                <div style={{padding: 10}}>
                                    <Text fw={600} fz={16} c={'#202020'} lh={'normal'}>User Details</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>{salesOrderQuery.data?.user?.fullname}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>+60 {salesOrderQuery.data?.user?.phone_number}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>{salesOrderQuery.data?.user?.email}</Text>
                                </div>
                                <div style={{padding: 10}}>
                                    <Text fw={600} fz={16} c={'#202020'} lh={'normal'}>Address</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>{salesOrderQuery.data?.address?.fullname}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>+60 {salesOrderQuery.data?.address?.phone_number}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>{salesOrderQuery.data?.address?.address_line_1}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>{salesOrderQuery.data?.address?.address_line_2}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>{salesOrderQuery.data?.address?.postal} {salesOrderQuery.data?.address?.city}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}>{salesOrderQuery.data?.address?.state}</Text>
                                </div>
                                <div style={{padding: 10}}>
                                    <Text fw={600} fz={16} c={'#202020'} lh={'normal'}>Order Details</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}><span style={{fontWeight: 500}}>Order ID:</span> {salesOrderQuery.data?.salesOrderId}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}><span style={{fontWeight: 500}}>Date:</span> {formatYYYY_MM_DD_HH_mm(salesOrderQuery.data?.createdAt)}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}><span style={{fontWeight: 500}}>Status:</span> {salesOrderQuery.data?.status}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}><span style={{fontWeight: 500}}>Courier Service:</span> {salesOrderQuery.data?.courierService}</Text>
                                    <Text fw={400} fz={14} c={'#000000'} lh={'normal'}><span style={{fontWeight: 500}}>Tracking Number:</span> {salesOrderQuery.data?.trackingNumber}</Text>
                                </div>
                            </div>
                            <div className={classes.orderCard}>
                                <div className={classes.orderCardTitleContainer}>
                                    <div style={{flex: 8}}>
                                        <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>Order</Text>
                                    </div>
                                    <div style={{flex: 2}}>
                                        <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>Quantity</Text>
                                    </div>
                                    <div style={{flex: 2}}>
                                        <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>Total</Text>
                                    </div>
                                </div>
                                {
                                salesOrderQuery.data?.buildId.map((item: any, index: number)=>(
                                    <div key={index} className={classes.orderCardContentContainer}>
                                        <div style={{flex: 8}}>
                                            <Text fw={500} fz={16} c={'#202020'} lh={'normal'} mb={15}>{item?.title}</Text>
                                            {
                                                salesOrderQuery.data?.buildItems[index].map((item: any, i: number)=>(
                                                    <Text key={i} fw={600} fz={12} c={'#202020'} lh={'normal'}><span style={{color: '#5D5D5D', fontWeight: '400'}}>{item?.displayName}</span></Text>
                                                ))
                                            }
                                        </div>
                                        <div style={{flex: 2, display: 'flex', alignItems: 'center'}}>
                                            <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>{item?.quantity}</Text>
                                        </div>
                                        <div style={{flex: 2, display: 'flex', alignItems: 'center'}}>
                                            <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>RM {convertToCurrency(item?.totalPrice)}</Text>
                                        </div>
                                    </div>
                                ))
                                }
                                {
                                salesOrderQuery.data?.prebuildId.map((item: any, index: number)=>(
                                    <div key={index} className={classes.orderCardContentContainer}>
                                        <div style={{flex: 8}}>
                                            <Text fw={500} fz={16} c={'#202020'} lh={'normal'} mb={15}>{item?.title}</Text>
                                            {
                                                salesOrderQuery.data?.prebuildItems[index].map((item: any, i: number)=>(
                                                    <Text key={i} fw={600} fz={12} c={'#202020'} lh={'normal'}><span style={{color: '#5D5D5D', fontWeight: '400'}}>{item?.displayName}</span></Text>
                                                ))
                                            }
                                        </div>
                                        <div style={{flex: 2, display: 'flex', alignItems: 'center'}}>
                                            <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>{item?.quantity}</Text>
                                        </div>
                                        <div style={{flex: 2, display: 'flex', alignItems: 'center'}}>
                                            <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>RM {convertToCurrency(item?.totalPrice)}</Text>
                                        </div>
                                    </div>
                                ))
                                }
                                {
                                salesOrderQuery.data?.items.map((item: any, index: number)=>(
                                    <div key={index} className={classes.orderCardContentContainer}>
                                        <div style={{flex: 8}}>
                                            <Text fw={500} fz={16} c={'#202020'} lh={'normal'}>{item?.displayName}</Text>
                                        </div>
                                        <div style={{flex: 2, display: 'flex', alignItems: 'center'}}>
                                            <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>{item?.quantity}</Text>
                                        </div>
                                        <div style={{flex: 2, display: 'flex', alignItems: 'center'}}>
                                            <Text fw={400} fz={14} c={'#202020'} lh={'normal'}>RM {convertToCurrency(item?.totalPrice)}</Text>
                                        </div>
                                    </div>
                                ))
                                }
                                <div className={classes.orderCardFooterContainer}>
                                    <Group justify='space-between'>
                                        <Text fw={500} fz={15} c={'#202020'} lh={'normal'}>Total</Text>
                                        <Text fw={500} fz={15} c={'#202020'} lh={'normal'}>RM {convertToCurrency(salesOrderQuery.data?.price)}</Text>
                                    </Group>
                                </div>
                            </div>
                            </Stack>
                            </Skeleton>
                        </Grid.Col>
                    </Grid>
                </Paper>
            </Box>
        </div>
    </div>
  );
}

export default WebOrderView;
